import React from "react";
import "./App.css";
import { Route, Routes } from "react-router";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Home from "./Pages/Home/Home";
import { HashRouter as Router } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "./Store Configuration/store";

function App() {
  const TITLE = "BL People Directory";
  const serverError = useSelector((state: RootState) => state.global.serverError);

  // console.log("🌍 Global State: serverError =", serverError);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{TITLE}</title>
      </Helmet>
      <Router>
        <div className="Main">
          {/* If the server crashes, show error message and hide the app */}
          {serverError ? (
            <div
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                right: 0,
                background: "red",
                color: "white",
                padding: "15px",
                textAlign: "center",
                fontSize: "18px",
                fontWeight: "bold",
                zIndex: 1000,
              }}
            >
              ⚠️ Something went wrong. Please try again later.
            </div>
          ) : (
            // Normal app when the server is running
            <Routes>
              <Route path="/:employeeCode" element={<Home />} />
              <Route path="/" element={<Home />} />
            </Routes>
          )}
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
